// extracted by mini-css-extract-plugin
module.exports = {"success":"styles_success__NC7uQ","danger":"styles_danger__LxlNd"};